import React, { useId } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
  indeterminate?: boolean;
  className?: string;
}
export function Checkbox({
  checked,
  onChange,
  label,
  description,
  disabled = false,
  indeterminate = false,
  className = ''
}: CheckboxProps) {
  const id = useId();
  return <label htmlFor={id} className={`
        flex items-start gap-3 cursor-pointer
        ${disabled ? 'cursor-not-allowed opacity-60' : ''}
        ${className}
      `} data-id="element-447">
      <div className="relative flex-shrink-0 mt-0.5" data-id="element-448">
        <input type="checkbox" id={id} checked={checked} onChange={e => onChange(e.target.checked)} disabled={disabled} className="sr-only peer" data-id="element-449" />
        <div className={`
            w-5 h-5 rounded-md border-2
            transition-colors duration-150
            flex items-center justify-center
            ${checked || indeterminate ? 'border-primary-500 bg-primary-500' : 'border-surface-300 bg-white'}
            ${!disabled && !checked ? 'hover:border-primary-300' : ''}
          `} data-id="element-450">
          <motion.div initial={false} animate={{
          scale: checked || indeterminate ? 1 : 0
        }} transition={{
          duration: 0.15
        }} data-id="element-451">
            {indeterminate ? <div className="w-2.5 h-0.5 bg-white rounded-full" data-id="element-452" /> : <CheckIcon className="w-3.5 h-3.5 text-white" strokeWidth={3} data-id="element-453" />}
          </motion.div>
        </div>
      </div>
      {(label || description) && <div className="flex-1" data-id="element-454">
          {label && <span className="text-body-md text-surface-900" data-id="element-455">{label}</span>}
          {description && <p className="text-body-sm text-surface-500 mt-0.5" data-id="element-456">
              {description}
            </p>}
        </div>}
    </label>;
}